<template>
  <div class="cmp-list">
    <div class="cmp-list__bar">
      <span class="cmp-list__hint">{{ $t('composite-cash-hint') }}</span>
      <v-btn
        color="primary"
        height="34"
        text
        class="cmp-list__add"
        @click="addPaymentRow"
      >
        <v-icon
          size="18"
          class="me-1"
        >
          mdi-plus
        </v-icon>
        {{ $t('addRow') }}
      </v-btn>
    </div>
    <div class="cmp-list__scroll">
    <div
      v-if="!paymentItems.length"
      class="cmp-empty"
    >
      <v-icon size="28">
        mdi-cash-multiple
      </v-icon>
      {{ $t('composite-empty') }}
    </div>
    <div
      v-for="(payment, i) in paymentItems"
      :key="i"
      class="cmp-row"
    >
      <span class="cmp-row__num">{{ i + 1 }}</span>
      <div class="cmp-row__fields">
        <v-row class="app-form-fields ma-0">
          <v-col
            class="px-3 xs"
            cols="12"
            md="3"
          >
            <autocomplete
              v-model="payment.account"
              :rules="[v => !!v || $t('is-required')]"
              :title="(type == 'pay' ? $t('reciever') : $t('payer'))"
              type="person"
              :new-btn="true"
              :value="payment.account"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <money
              v-model="payment.amount"
              :label="$t('amount')"
              :dense="true"
              :outlined="true"
              :rules="[v => !!v || $t('is-required')]"
              :solo="false"
              :clearable="true"
              value-when-is-empty=""
              :options="options"
              :value-options="{'max':(payment.bank ? Number(payment.bank.remain.currency_remain) : 9999999999999999999)}"
            />
          </v-col>
          <v-col
            class="px-3 xs"
            cols="12"
            md="2"
            sm="3"
          >
            <autocomplete
              v-model="payment.bank"
              :rules="[v => !!v || $t('is-required')]"
              :title="$t('bank') + '/' + $t('cash')"
              :currency-prop="formHeader.currency.id"
              type="bankCash"
            />
          </v-col>
          <v-col
            cols="12"
            md="2"
          >
            <template>
              <v-text-field
                :id="'date' + i"
                v-model="payment.date"
                :label="$t('date')"
                :rules="[v => !!v || $t('is-required')]"
                clear-icon="flaticon2-close-cross"
                outlined
                dense
                clearable
              />
              <date-picker
                v-model="payment.date"
                :element="'date' + i"
                :locale="$store.state.date_locale"
                :format="$store.state.date_format"
                auto-submit
                :min="$store.state.startDate"
                :max="$store.state.endDate"
                :color="$vuetify.theme.themes[$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                @close="setDate"
              />
            </template>
          </v-col>
          <v-col
            cols="12"
            md="2"
          >
            <autocomplete
              v-model="payment.given"
              :title="$t('accountGiven')"
              type="given"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <aicomplete
              v-model="payment.branch"
              title="branch"
              type="branch"
              :set-init="true"
              :new-btn="true"
            />
          </v-col>
        </v-row>
      </div>
      <button
        type="button"
        class="cmp-row__remove"
        :aria-label="$t('delete')"
        :title="$t('delete')"
        @click="removeRow(i)"
      >
        <v-icon
          size="18"
          color="pink"
        >
          mdi-trash-can-outline
        </v-icon>
      </button>
    </div>
    </div>
  </div>
</template>

<script>
  import General from '@/Mixins/general'
  export default {
    name: 'CompositeHeader',
    mixins: [General],
    props: ['formHeader', 'type'],
    data () {
      return {
        paymentItems: [],
        options: {
          locale: 'en-US',
          prefix: '',
          suffix: '  ',
          precision: 0,
        },
      }
    },
    computed: {
      totalAmount () {
        return this.paymentItems.reduce((sum, payment) => {
          return +sum + +(payment.amount || 0)
        }, 0)
      },
    },
    watch: {
      $data: {
        handler (newVal, oldVal) {
          this.emitData()
        },
        deep: true,
      },
    },
    mounted () {
    },
    methods: {
      removeRow (i) {
        this.paymentItems.splice(i, 1)
      },
      emitData () {
        var data = {
          totalAmount: this.totalAmount,
          items: this.paymentItems,
        }
        this.$emit('input', data)
      },
      addPaymentRow () {
        var payemnt = {
          type: this.type,
          date: (this.formHeader ? this.formHeader.date : null),
          account: (this.formHeader ? this.formHeader.account : null),
          amount: null,
          bank: null,
          given: null,
          content: null,
          branch: null,
        }
        this.paymentItems.push(payemnt)
      },
      clearForm () {
        this.paymentItems = []
      },
    },
  }
</script>

<style scoped>

</style>
